import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  Alert,
  Backdrop,
  Box,
  Button,
  Grid,
  MenuItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import {
  createProductValidationThunk,
  updateProductValidationThunk,
} from "store/reducers/product/productValidationSlice";
import FileDropZone from "components/FileDropZone";
import { LazyLoadImage } from "react-lazy-load-image-component";
import addURLPrefix from "utils/addURLPrefix";
import SimpleBarHorizontal from "components/SimpleBarHorizontal";

const validation = yup.object({
  name: yup.string("Enter name").required("Name required"),
  desc: yup.string("Enter desc"),
  logic: yup.string("Enter logic").required("Logic required"),
  image: yup.mixed("Add an image").nullable(),
});

const dynamicFormInitials = {
  name: "",
  type: "text",
  required: false,
};
const ProductValidationCreate = ({ productValidation, fullGrid = false }) => {
  const [clearImage, setClearImage] = useState(false);
  const [files, setFiles] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    formik.setFieldValue("image", files[0] ?? null);
  }, [files]);

  const formik = useFormik({
    initialValues: {
      name: productValidation?.name ?? "",
      desc: productValidation?.desc ?? "",
      logic: productValidation?.logic ?? "",
      image: null,
    },
    validationSchema: validation,

    onSubmit: (data) => {
      
      const newData = { ...data ,credential_format:JSON.stringify(credentialFormat)};
      console.log(newData);
      if (productValidation?.image && !clearImage) {
        delete newData["image"];
      }
      console.log(newData);
      if (productValidation) {
        dispatch(
          updateProductValidationThunk({
            id: productValidation.id,
            data: newData,
          })
        );
      } else {
        dispatch(createProductValidationThunk(newData));
      }
    },
    validateOnChange: false,
  });

  const { status } = useSelector((state) => state.productValidation);

  useEffect(() => {
    console.log("Error", status.errorMessage);
    if (status.errorMessage) {
      Object.keys(status.errorMessage).forEach((key) => {
        console.log(key, status.errorMessage[key][0]);
        formik.setFieldError(key, status.errorMessage[key][0]);
      });
    }
  }, [status.errorMessage]);

  const [backDropImage, setBackDropImage] = React.useState(null);
  const [openBackDrop, setOpenBackDrop] = React.useState(false);

  const onImageClick = (image) => {
    setBackDropImage(image);
    setOpenBackDrop(true);
  };
  const handleBackdropClose = () => {
    setOpenBackDrop(false);
  };

  const isFullWidth = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const [credentialFormat, setCredentialFormat] = React.useState([]);
  const [showCredentialForm, setShowCredentialForm] = React.useState(false);
  const [dynamicFormState, setDynamicFormState] =
    React.useState(dynamicFormInitials);
  const [dynamicFormErrors, setDynamicFormErrors] = React.useState({});

  const handleFormChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setDynamicFormState({ ...dynamicFormState, [name]: value });
  };

  const removeCredentialFormat = (i) => {
    setCredentialFormat((state) => state.filter((item, index) => index !== i));
  };

  const addCredentialItem = (data) => {
    if (data.name) {
      setDynamicFormErrors({});
      if(credentialFormat){
        setCredentialFormat([...credentialFormat, data]);
      }else{
        setCredentialFormat([data]);
      }
      
    } else {
      setDynamicFormErrors({ name: "Field required" });
    }
  };

  useEffect(() => {
    if (productValidation) {
      console.log("pv",productValidation)
      console.log("cred",productValidation.credential_format)
      setCredentialFormat(productValidation.credential_format);
    }
  }, [productValidation]);

  return (
    <Box marginTop={2}>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1.5} paddingY={1}>
          <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
            <Stack spacing={2}>
              <TextField
                label="Name"
                variant="outlined"
                name="name"
                fullWidth
                value={formik.values.name}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.name)}
                helperText={formik.errors.name}
                autoComplete="new-password"
                type="text"
                required
              />
              <TextField
                label="Desc"
                variant="outlined"
                name="desc"
                fullWidth
                value={formik.values.desc}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.desc)}
                helperText={formik.errors.desc}
                autoComplete="new-password"
                type="text"
                multiline
                maxRows={4}
              />

              <TextField
                label="Logic"
                variant="outlined"
                name="logic"
                fullWidth
                value={formik.values.logic}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.logic)}
                helperText={formik.errors.logic}
                autoComplete="new-password"
                type="text"
                required
              />
              <Box>
                <Typography variant="h6" color="gray" marginTop={2}>
                  Choose a picture
                </Typography>
                {productValidation?.image && !clearImage ? (
                  <>
                    <Typography marginY={2} color="text.secondary">
                      Image
                    </Typography>
                    <Paper
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: 0.5,
                        position: "relative",
                        marginLeft: 1,
                      }}
                    >
                      <LazyLoadImage
                        alt="validation image"
                        src={addURLPrefix(productValidation?.image)}
                        height={200}
                        width={200}
                        style={{ objectFit: "cover", borderRadius: 4 }}
                        onClick={() =>
                          onImageClick(addURLPrefix(productValidation?.image))
                        }
                      />
                    </Paper>
                    <Box>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => setClearImage(true)}
                        sx={{ margin: 1 }}
                        fullWidth={false}
                      >
                        Remove image
                      </Button>
                    </Box>
                  </>
                ) : (
                  <FileDropZone
                    maxFiles={1}
                    accept={{
                      "image/png": [".png"],
                      "image/jpeg": [".jpg", ".jpeg"],
                    }}
                    mode="image"
                    files={files}
                    setFiles={setFiles}
                  />
                )}
              </Box>
              
            </Stack>
          </Grid>
        </Grid>

        <Stack direction="column" sx={{ mt: 2 }}>
          <Button
            variant="outlined"
            onClick={() => setShowCredentialForm((state) => !state)}
            sx={{ width: 200 }}
          >
            {showCredentialForm
              ? "Hide credential form"
              : "show credential form"}
          </Button>
          {credentialFormat?.length > 0 && showCredentialForm && (
            <SimpleBarHorizontal>
              <Box
                sx={{
                  backgroundColor: "#e7ebf0",
                  borderRadius: 2,
                  flex: 1,
                  mt: 2,
                }}
                padding={1}
              >
                <TableContainer component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ minWidth: 100 }}>Name</TableCell>
                        <TableCell align="center" sx={{ minWidth: 80 }}>
                          Type
                        </TableCell>
                        <TableCell align="center" sx={{ minWidth: 80 }}>
                          Required
                        </TableCell>
                        <TableCell>&nbsp;</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {credentialFormat.map((cred, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {cred.name}
                          </TableCell>
                          <TableCell align="center">{cred.type}</TableCell>
                          <TableCell align="center">
                            {cred.required ? "Yes" : "No"}
                          </TableCell>

                          <TableCell align="center">
                            <LoadingButton
                              variant="outlined"
                              color="error"
                              onClick={() => {
                                removeCredentialFormat(index);
                              }}
                            >
                              Delete
                            </LoadingButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </SimpleBarHorizontal>
          )}

          {showCredentialForm && (
            <Grid container columnSpacing={2} rowSpacing={2}>
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  label="Name"
                  variant="outlined"
                  name="name"
                  fullWidth
                  sx={{ mt: 2 }}
                  value={dynamicFormState?.name}
                  onChange={handleFormChange}
                  autoComplete="new-password"
                  error={Boolean(dynamicFormErrors?.name)}
                  helperText={dynamicFormErrors?.name}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  label="Type"
                  variant="outlined"
                  name="type"
                  select
                  fullWidth
                  sx={{ mt: 2 }}
                  value={dynamicFormState?.type}
                  error={Boolean(dynamicFormErrors?.type)}
                  helperText={dynamicFormErrors?.type}
                  onChange={handleFormChange}
                  autoComplete="new-password"
                  required
                >
                  <MenuItem value="text">Text</MenuItem>
                  <MenuItem value="number">Number</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  label="Required"
                  variant="outlined"
                  name="required"
                  select
                  fullWidth
                  sx={{ mt: 2 }}
                  value={dynamicFormState?.required}
                  onChange={handleFormChange}
                  autoComplete="new-password"
                  error={Boolean(dynamicFormErrors?.required)}
                  helperText={dynamicFormErrors?.required}
                >
                  <MenuItem value={true}>Yes</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    addCredentialItem(dynamicFormState);
                  }}
                  sx={{ mt: 2 }}
                >
                  Add
                </Button>
              </Grid>
            </Grid>
          )}

          <Grid container columnSpacing={2} rowSpacing={2}>
            <Grid item xs={12} md={6} lg={4}>
              <Stack direction="column">
                {((!productValidation && status?.error === "create") ||
                  (productValidation && status?.error === "update")) && (
                  <Alert sx={{ my: 1 }} severity="error">
                    Error occurred
                  </Alert>
                )}

                {((!productValidation && status?.success === "create") ||
                  (productValidation && status?.success === "update")) && (
                  <Alert sx={{ my: 1 }} severity="success">
                    Success
                  </Alert>
                )}
                <LoadingButton
                  variant="contained"
                  type="submit"
                  sx={{ paddingX: 10, marginTop: 1 }}
                  loading={
                    status?.loading === "create" || status?.loading === "update"
                  }
                >
                  {productValidation ? "Edit validation" : "Add validation"}
                </LoadingButton>
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </form>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackDrop}
        onClick={handleBackdropClose}
      >
        <LazyLoadImage
          alt="machine image"
          src={backDropImage}
          height="95%"
          width="95%"
          style={{ objectFit: "contain" }}
        />
      </Backdrop>
    </Box>
  );
};

export default ProductValidationCreate;
